export default {
  path: "/app/asset",
  name: "asset",
  redirect: "/app/asset/asset-company",
  component: () => import("./layout"),
  children: [
    {
      name: "myListAssetCanEdit",
      path: "/app/asset/asset-can-edit",
      component: () =>
        import("./components/assetManager/my-asset-editor.list.vue"),
      meta: {
        appName: "myListAssetCanEdit",
      },
    },
    {
      name: "myListAssetCanLiquidated",
      path: "/app/asset/asset-can-liquidated",
      component: () =>
        import("./components/assetManager/my-asset-can-liquidated.list.vue"),
      meta: {
        appName: "myListAssetCanLiquidated",
      },
    },
    {
      name: "myListAssetCanAllocatedOrRecover",
      path: "/app/asset/asset-can-allocated-or-recover",
      component: () =>
        import(
          "./components/assetManager/my-asset-can-allocated-or-recover.list.vue"
        ),
      meta: {
        appName: "myListAssetCanAllocatedOrRecover",
      },
    },
    //CHILD APP
    {
      name: "assetCategory",
      path: "/app/asset/asset-category",
      component: () => import("./childApp/assetCategory"),
      meta: {
        appName: "assetCategory",
      },
    },
    {
      name: "assetCategoryGroup",
      path: "/app/asset/asset-group",
      component: () => import("./childApp/assetCategoryGroup"),
      meta: {
        appName: "assetCategoryGroup",
      },
    },
    {
      name: "assetManufacturer",
      path: "/app/asset/asset-manufacturer",
      component: () => import("./childApp/assetManufacturer"),
      meta: {
        appName: "assetManufacturer",
      },
    },
    {
      name: "assetModel",
      path: "/app/asset/asset-model",
      component: () => import("./childApp/assetModel"),
      meta: {
        appName: "assetModel",
      },
    },
    {
      name: "assetSupplier",
      path: "/app/asset/asset-supplier",
      component: () => import("./childApp/assetSupplier"),
      meta: {
        appName: "assetSupplier",
      },
    },
    // ASSET DEPARTMENT
    {
      name: "assetCompany",
      path: "/app/asset/asset-company",
      component: () => import("./components/assetManager/asset-company"),
      meta: {
        appName: "assetCompany",
      },
    },
    {
      name: "assetCompanyAllocated",
      path: "/app/asset/asset-company-allocated",
      component: () =>
        import("./components/assetManager/asset-company.list-allocated"),
      meta: {
        appName: "assetCompanyAllocated",
      },
    },
    {
      name: "assetCompanyOutOfStock",
      path: "/app/asset/asset-company-out-of-stock",
      component: () =>
        import("./components/assetManager/asset-company.list-out-of-stock"),
      meta: {
        appName: "assetCompanyOutOfStock",
      },
    },
    {
      name: "assetCompanyAdd",
      path: "/app/asset/asset-company-add",
      component: () => import("./components/assetManager/asset-company.add"),
      meta: {
        appName: "assetCompanyAdd",
      },
    },
    {
      name: "assetCompanyDetailView",
      path: "/app/asset/asset-company/:idAsset/detail-view",
      component: () =>
        import("./components/assetManager/asset-company.detail-view"),
      meta: {
        appName: "assetCompanyDetailView",
      },
    },
    //ASSET FOR PERSONAL
    {
      name: "myAssetConfirm",
      path: "/app/asset/my-asset-confirm",
      component: () =>
        import("./components/assetManager/asset-company.list-confirm"),
      meta: {
        appName: "myAssetConfirm",
      },
    },
    {
      name: "myAssetAllocated",
      path: "/app/asset/my-asset-allocated",
      component: () =>
        import("./components/assetManager/my-asset.list-allocated"),
      meta: {
        appName: "myAssetAllocated",
      },
    },
    // REPORT
    {
      name: "assetReport",
      path: "/app/asset/report-asset",
      component: () => import("./components/assetManager/asset-company.report"),
      meta: {
        appName: "assetReport",
      },
    },
    {
      name: "assetTotalList",
      path: "/app/asset/total-list",
      component: () =>
        import("./components/assetManager/asset-company.total-list"),
      meta: {
        appName: "assetTotalList",
      },
    },
    // FORM IN
    {
      name: "handoverDetail",
      path: "/app/asset/handover-form/:handoverId/detail",
      component: () =>
        import("./components/form/handover/handover-form.detail"),
    },
    {
      name: "handoverList",
      path: "/app/asset/handover-form",
      component: () => import("./components/form/handover/handover-form.list"),
      meta: {
        appName: "handoverList",
      },
    },
  ],
};
